import {TableColumn} from "../../../interfaces/table/table-column";
import {TableColumnType} from "../../../enums/table-column-type";

export enum AssetDetailsTableColumn {
  JobNumber = 'job_number',
  JobType = 'job_type',
  Status = 'status',
  DueDate = 'due_date',
  CompleteDate = 'complete_date',
}

export function constructDetailsColumns(
  showDueDate: boolean,
  showCompleteDate: boolean,
): TableColumn[] {
  const columns: TableColumn[] = [
    {
      columnId: AssetDetailsTableColumn.JobNumber,
      header: 'Job Number',
      type: TableColumnType.Text
    },
    {
      columnId: AssetDetailsTableColumn.JobType,
      header: 'Job Type',
      type: TableColumnType.Text
    },
    {
      columnId: AssetDetailsTableColumn.Status,
      header: 'Status',
      type: TableColumnType.Tag
    },
  ];
  if (showDueDate) {
    columns.push({
      columnId: AssetDetailsTableColumn.DueDate,
      header: 'Due Date',
      type: TableColumnType.Text
    });
  }
  if (showCompleteDate) {
    columns.push({
      columnId: AssetDetailsTableColumn.CompleteDate,
      header: 'Completion Date',
      type: TableColumnType.Text
    });
  }
  return columns;
}
